var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdatedLocationColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.1647C0.268486 1.5769 0.735365 1.30472 1.39121 1.38752C1.30431 0.733316 1.61133 0.149614 2.27414 0L12.6533 0.00491883C12.7709 0.0315625 12.9402 0.229955 13.0308 0.323003C14.0695 1.39285 14.9979 2.58854 16.0124 3.68257C16.0739 3.77684 16.0715 3.87645 16.0797 3.98343C16.1207 4.50893 16.1395 5.64805 16.0797 6.15551C16.0727 6.21495 16.0747 6.26085 16.0161 6.29652H15.4025L15.341 6.23503V4.16912H12.9886C12.7492 4.16912 12.2319 3.61001 12.2319 3.37145V0.691916H2.35243C2.23397 0.691916 2.04951 0.989095 2.08476 1.11985L2.11346 18.6038L2.30857 18.8178L15.066 18.8465C15.2369 18.7875 15.3197 18.7391 15.3422 18.5497C15.4787 17.3918 15.2406 15.9694 15.3394 14.7831L15.4029 14.6421H16.0165L16.0801 14.7831C16.0079 15.9694 16.1686 17.2532 16.0797 18.428C16.0309 19.072 15.6857 19.5073 15.0164 19.5532C15.0943 20.2111 14.8163 20.7153 14.1962 20.9423H0.900146C0.429988 20.8362 0.106575 20.514 0 20.0422V2.1647ZM14.8914 3.47393L12.9275 1.30554V3.24889C12.9275 3.29685 13.1046 3.47393 13.1525 3.47393H14.8914ZM1.3908 2.08313C1.09321 2.06714 0.737825 2.06058 0.694375 2.4299L0.693555 19.8606C0.683718 20.0201 0.781274 20.1406 0.910804 20.2164L13.9719 20.2484C14.3413 20.2049 14.3347 19.8495 14.3187 19.552H2.27045C1.94704 19.552 1.3908 18.9957 1.3908 18.6723V2.08313Z",
    fill: "url(#paint0_linear_3264_41406)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4724 8.38281H3.47656V9.07842H10.4724V8.38281Z",
    fill: "url(#paint1_linear_3264_41406)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4724 10.4688H3.47656V11.1644H10.4724V10.4688Z",
    fill: "url(#paint2_linear_3264_41406)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4724 12.5566H3.47656V13.2522H10.4724V12.5566Z",
    fill: "url(#paint3_linear_3264_41406)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69036 3.47461V4.14972L7.62929 4.2112H3.53805L3.47656 4.14972V3.47461H7.69036Z",
    fill: "url(#paint4_linear_3264_41406)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69214 2.08301H4.86914V2.77861H7.69214V2.08301Z",
    fill: "url(#paint5_linear_3264_41406)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21316 2.77861H3.47656V2.08301H4.15167L4.21316 2.14449V2.77861Z",
    fill: "url(#paint6_linear_3264_41406)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4697 16.4226C16.6485 16.4647 16.8273 16.5067 17.0041 16.5538H18.1919C18.2988 16.5305 18.4061 16.5089 18.5133 16.4874C18.7362 16.4425 18.959 16.3976 19.1779 16.3383C21.5813 15.6851 23.3141 13.6888 23.631 11.2201C23.6356 11.1834 23.6492 11.148 23.6628 11.1127C23.6691 11.0962 23.6755 11.0797 23.6809 11.0631V9.87469C23.6755 9.85809 23.6691 9.8416 23.6628 9.8251C23.6492 9.78976 23.6356 9.75435 23.631 9.71763C23.1848 6.22955 19.9637 3.87203 16.4876 4.49004C13.8205 4.96404 11.8133 7.18605 11.535 9.97334C11.2775 12.5503 12.8742 15.1533 15.3252 16.0979C15.6936 16.24 16.0817 16.3313 16.4697 16.4226ZM19.3354 14.458L19.453 13.9771C19.3922 14.0057 19.294 14.0384 19.1594 14.0756C19.0244 14.1128 18.9029 14.1318 18.7961 14.1318C18.5687 14.1318 18.4086 14.0945 18.3157 14.0196C18.2234 13.9446 18.1774 13.8037 18.1774 13.5972C18.1774 13.5155 18.1912 13.3935 18.2203 13.2339C18.2484 13.0733 18.2808 12.9305 18.3168 12.8057L18.7559 11.251C18.7989 11.1083 18.8284 10.9514 18.8443 10.7802C18.8605 10.6094 18.8681 10.4899 18.8681 10.422C18.8681 10.0942 18.7531 9.82814 18.5232 9.6229C18.2933 9.41782 17.9659 9.31528 17.5417 9.31528C17.3056 9.31528 17.056 9.35723 16.7918 9.44106C16.5277 9.52466 16.2515 9.62539 15.9626 9.74302L15.8447 10.2243C15.9307 10.1924 16.0333 10.1582 16.1533 10.1227C16.2727 10.0874 16.3899 10.0691 16.5039 10.0691C16.7367 10.0691 16.8934 10.1088 16.9756 10.187C17.0578 10.2654 17.0991 10.4048 17.0991 10.6042C17.0991 10.7144 17.086 10.8369 17.0589 10.97C17.0322 11.1039 16.9989 11.2455 16.9596 11.395L16.5186 12.956C16.4794 13.12 16.4507 13.2668 16.4327 13.3971C16.4148 13.5272 16.4062 13.655 16.4062 13.7792C16.4062 14.1 16.5247 14.3644 16.7617 14.5732C16.9987 14.781 17.331 14.8857 17.7582 14.8857C18.0364 14.8857 18.2806 14.8493 18.4907 14.7762C18.7006 14.7033 18.9825 14.5973 19.3354 14.458ZM19.2572 8.14244C19.4623 7.95222 19.5644 7.72088 19.5644 7.45001C19.5644 7.17973 19.4625 6.94794 19.2572 6.75531C19.0525 6.56321 18.8059 6.46685 18.5175 6.46685C18.2282 6.46685 17.9806 6.56298 17.774 6.75531C17.5674 6.94794 17.4639 7.17966 17.4639 7.45001C17.4639 7.72088 17.5674 7.95215 17.774 8.14244C17.981 8.33334 18.2281 8.42886 18.5175 8.42886C18.806 8.42886 19.0525 8.33334 19.2572 8.14244Z",
    fill: "url(#paint7_linear_3264_41406)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3264_41406",
    x1: 8.0589,
    y1: 0,
    x2: 8.0589,
    y2: 20.9423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00754A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3264_41406",
    x1: 6.97447,
    y1: 8.38281,
    x2: 6.97447,
    y2: 9.07842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00754A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3264_41406",
    x1: 6.97447,
    y1: 10.4688,
    x2: 6.97447,
    y2: 11.1644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00754A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3264_41406",
    x1: 6.97447,
    y1: 12.5566,
    x2: 6.97447,
    y2: 13.2522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00754A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3264_41406",
    x1: 5.58346,
    y1: 3.47461,
    x2: 5.58346,
    y2: 4.2112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00754A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3264_41406",
    x1: 6.28064,
    y1: 2.08301,
    x2: 6.28064,
    y2: 2.77861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00754A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3264_41406",
    x1: 3.84486,
    y1: 2.08301,
    x2: 3.84486,
    y2: 2.77861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00754A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3264_41406",
    x1: 17.5944,
    y1: 4.3916,
    x2: 17.5944,
    y2: 16.5538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00754A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatedLocationColor);
export default __webpack_public_path__ + "static/media/updatedLocation-color.6440edfe015b7dc196dd09bda14f673c.svg";
export { ForwardRef as ReactComponent };